export default __webpack_public_path__ + "static/Earth-Day-Sub-Banner-Mobile-21adf45c0353265f7b39437e8b1f4f2a.webp";